import { Button, Modal, Text } from "@marketplace/ui";
import { notifications } from "@marketplace/ui/notifications";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { deleteProductVariantModalAtom } from "../../atoms/product-detail-page-atom";
import { useDeleteProductVariantMutation } from "../../hooks/mutations/use-delete-product-variant-mutation";

export const DeleteVariantModal = () => {
  const { t: tProduct } = useTranslation("product");
  const { t: tCommon } = useTranslation("common");
  const { visible, data } = useAtomValue(deleteProductVariantModalAtom);
  const resetDeleteProductVariantModal = useResetAtom(
    deleteProductVariantModalAtom
  );

  const { mutateAsync: mutateDeleteProductVariant, isPending } =
    useDeleteProductVariantMutation();

  const handleDelete = async () => {
    try {
      if (!data?.variantId) return;

      await mutateDeleteProductVariant({
        variantId: data.variantId
      });

      notifications.show({
        message: tProduct("notifications.successDeleteProductVariant")
      });
      resetDeleteProductVariantModal();
    } catch {
      notifications.show({
        variant: "error",
        message: tProduct("notifications.failedToDeleteProductVariant")
      });
    }
  };

  return (
    <Modal.Root
      opened={visible}
      onClose={resetDeleteProductVariantModal}
      size={334}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body classNames={{ body: "!p-[42px]" }}>
          <Text type="paragraph" className="text-center mb-6">
            {tProduct("modal.deleteVariantModal.description")}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button
              variant="secondary"
              fullWidth
              onClick={resetDeleteProductVariantModal}
            >
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleDelete}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
